<template>
  <div class="w-100 h-100 bg-light">
    <div class="col-12 d-flex flex-row justify-content-between align-items-start pt-2 h-100">
      <div class="card col-3s h-100 shadow-lg rounded-lg p-3">
        <div class="card-body pb-0">
          <div class="media flex-column justify-content-center align-items-center border-bottom">
            <img
              ref="imageAvatar"
              src="@assets/images/users/avatar-7.jpg"
              class="avatar-xxl rounded-circle"
              alt="avatar"
            />
            <div class="button_container text-dark bg-white rounded-lg">
              <input 
                type='file' 
                ref="attachmentField"
                hidden=true
                @change="onAddAttachment"
              />
              <b-nav-item-dropdown
                right
                no-caret
                variant="black"
                class="dropdown d-none d-lg-block"
              >
                <template v-slot:button-content>
                  <p title="Setting" class="h4 my-0 py-0 text-muted">
                    ...
                  </p>
                </template>
                <!-- item-->
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  title="Edit"
                  @click="onClickActions('edit_side_bar', model)"
                >
                  <i class="uil uil-edit mr-1" />
                  Edit
                </b-dropdown-item>
                <b-dropdown-item 
                  href="javascript:void(0);"
                  class="notify-item"
                  title="Add Attachments"
                  @click="onClickAddAttachment()"
                >
                  <i class="uil uil-file-plus mr-1" />
                  Add Attachment
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </div>
            <div class="text-center w-100">
              <h5 class="mt-3 mb-0">{{ model.full_name }}</h5>
              <h6 class="font-weight-normal mt-1 mb-2 text-muted">
                {{ model.present_work }}
              </h6>
              <p
                v-if="model.status"
                class="badge badge-pill text-white my-0 mb-2"
                :class="model.status == 'pending' ? 'badge-warning' : 'badge-success'"
              >
                {{ `${model.status.charAt(0).toUpperCase()}${model.status.slice(1)}` }}
              </p>
            </div>
            <div v-if="computedSocmed" class="mt-1 h6">
              <a
                v-if="model.facebook"
                :href="model.facebook"
                title="facebook"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-facebook text-primary"></i>
              </a>
              <a
                v-if="model.twitter"
                :href="model.twitter"
                title="twitter"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-twitter text-info"></i>
              </a>
              <a
                v-if="model.dribble"
                :href="model.dribbble"
                title="dribbble"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-dribbble text-danger"></i>
              </a>
              <a
                v-if="model.behance"
                :href="model.behance"
                title="behance"
                target="_blank"
                class="mx-1"
              >
                <i class="uil-behance"></i>
              </a>
            </div>
          </div>
          <div class="text-left mb-3 border-bottom">
            <ul class="list-unstyled events mb-0 font-1 text-muted">
              <li class="my-3 text-uppercase">
                <i class="mr-2 uil-user"></i>
                {{ model.gender || "-" }}
              </li>
              <li class="my-3">
                <i class="mr-2 uil-gift"></i>
                {{ model.date_of_birth | date  }}
              </li>
              <li class="my-3">
                <i class="mr-2 uil-location-point"></i>
                {{ model.city || "" }} {{ model.country || "-" }}
              </li>
              <li class="my-3">
                <i class="mr-2 uil-phone"></i>
                {{ model.contact_no || "-" }}
              </li>
              <li class="my-3">
                <i class="mr-2 uil-envelope"></i>
                {{ model.email || "N/A" }}
              </li>
              <li class="my-3">
                <i class="mr-2 uil-globe"></i>
                {{ model.website || "-" }}
              </li>
              <li class="my-3">
                <i class="mr-2 uil-constructor"></i>
                {{ model.functions ? model.functions[0]?.name : "-" }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="w col-8s h-100">
        <b-tabs class="">
          <b-tab title="Suitable Jobs" active>
            <div v-if="model.full_name" style="max-height:60vh; overflow-y:auto;overflow-x:hidden">
              <DataTable 
                ref="list"
                :userData="model"
              />
            </div>
          </b-tab>
          <b-tab title="Documents">
            <div class="row">
              <div class="text-left col-lg-12">
                <div class="card">
                  <div class="card-body">
                    <h5 class="card-title border-bottom">Resume</h5>
                    <div 
                      v-for="(item, idx) in attachmentDatas"
                      :key="item._id"
                    >
                      <div class="section">
                        <div class="'collapsible">
                          <div class="p-1 px-2">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <img 
                                  src="@assets/images/projects/project-1.jpg"
                                  class="avatar-sm rounded"
                                  alt="file-image"
                                >
                              </div>
                              <div class="col pl-0" style="white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;">
                                  <a href="javascript:void(0);" class="text-muted font-weight-bold">
                                    {{ item.fileName }} 
                                    <span class="ml-2 text-right badge badge-pill badge-soft-primary">original</span>
                                  </a>
                                  <p class="mb-0">{{ item.size.$numberDecimal | bytes }}</p>
                              </div>
                              <div class="col-auto">
                                <a
                                  @click="onDownloadAttachment(item._id, false)"
                                  data-toggle="tooltip" 
                                  data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                  data-original-title="Download">
                                    <i class="uil uil-cloud-download font-size-14"></i>
                                </a>
                                <a
                                  @click="onDeleteAttachment(item._id, idx)"
                                  data-toggle="tooltip" data-placement="bottom" title="Delete Attachment" class="btn btn-link text-danger btn-lg p-0" data-original-title="Delete">
                                    <i class="uil uil-multiply font-size-14"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div 
                      v-for="(item, idx) in attachmentPDFDatas"
                      :key="item._id + 'pdf'"
                    >
                      <div class="section">
                        <div :class="[item.isActive ? 'active' : '', 'collapsible']" @click="item.isActive = !item.isActive">
                          <div class="p-1 px-2">
                            <div class="row align-items-center">
                              <span class="toggleIcon" id="toggleIcon">{{ !item.isActive ? '+' : '-' }}</span>
                              <div class="col-auto">
                                  <img src="@assets/images/projects/project-1.jpg" class="avatar-sm rounded" alt="file-image">
                              </div>
                              <div class="col pl-0" style="white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;">
                                  <a href="javascript:void(0);" class="text-muted font-weight-bold">{{ item.fileName }} <span :class="`ml-2 text-right badge badge-pill badge-soft-${item.converted_file ? 'danger' : 'primary'}`">{{ item.converted_file ? 'converted' : 'original' }}</span></a>
                                  <p class="mb-0">{{ item.size.$numberDecimal | bytes}}</p>
                              </div>
                              <div class="col-auto">
                                <a
                                  @click="onDownloadAttachment(item._id, item.converted_file)"
                                  data-toggle="tooltip" 
                                  data-placement="bottom" title="Download Attachment" class="btn btn-link text-muted btn-lg p-0" 
                                  data-original-title="Download">
                                    <i class="uil uil-cloud-download font-size-14"></i>
                                </a>
                                <a
                                  @click="onDeleteAttachment(item._id, idx)"
                                  data-toggle="tooltip" data-placement="bottom" title="Delete Attachment" class="btn btn-link text-danger btn-lg p-0" data-original-title="Delete">
                                    <i class="uil uil-multiply font-size-14"></i>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <pdf
                        v-for="i in item.numPages"
                        :key="i"
                        :src="item.src"
                        :page="i"
                        style="display: inline-block; width: 100%"
                        v-show="item.isActive"
                      />
                    </div>
                  </div>
                </div>  
              </div>
            </div>
          </b-tab>
          <b-tab title="Applied Position">
            <div class="col-12 p-4 bg-white">
              <div class="card-body card_body_background">
                <div
                  class="text-center"
                  v-if="!model.applications.length"
                >
                    No application/s found.
                </div>
                <div
                  class="card mb-0"
                  v-for="item in model.applications"
                  :key="item._id">
                    <div class="p-2">
                      <applicantProgress 
                        :status="item.status"
                        :applicant="item"
                        employment
                      />
                    </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Activities">
            <div class="card">
              <div class="card-body overflow-auto" style="max-height:60vh">
                <div 
                  class="text-center"
                  v-if="!model.activities.length"
                >
                  {{ $t('candidate.form.empty_activities') }}.
                </div>

                <div class="custom-timeline pl-4" 
                  v-for="item in model.activities"
                  :key="item._id"
                >
                  <ul class="list-unstyled events">
                    <li class="event-list" >
                      <div v-if="item.type == 'application'">
                        <div class="event-date text-muted pt-2">
                          <span class="font-size-15">
                            {{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('hh:mm A')}} | {{ item.recruiter_id ? item.recruiter_id.full_name : '' }}
                          </span>
                        </div>
                        <div class="media">
                          <div class="media-body">
                            
                            <div class="card">
                              <div class="card-body mt-3">
                                <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                <p class="text-muted">
                                  {{ item.description }}
                                </p>
                                <div v-if="item.job_id">Position: {{ item.job_id.title }}</div>
                                <div v-if="item.job_id">Company: {{ item.job_id.company_id.name }}</div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div v-else-if="item.type == 'schedule' || item.type == 'reschedule'">
                        <div class="event-date text-muted pt-2">
                          <span class="font-size-15">
                            {{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('hh:mm A')}} | {{ item.recruiter_id ? item.recruiter_id.full_name : '' }}
                          </span>
                        </div>
                        <div class="media">
                          <div class="media-body">
                            
                            <div class="card">
                              <div class="card-body mt-3">
                                <h5 class="mt-0"><i class="uil uil-calendar-alt"></i> {{ item.title }} </h5>
                                <p class="text-muted">
                                  {{ item.description }}
                                </p>
                                <div v-if="item.job_id">Position: {{ item.job_id.title }}</div>
                                <div v-if="item.job_id">Company: {{ item.job_id.company_id.name }}</div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="event-date text-muted pt-2">
                          <span class="font-size-15">
                            {{item.date_created | date('MMMM D, YYYY')}} | {{item.date_created | date('hh:mm A')}} | {{ item.recruiter_id ? item.recruiter_id.full_name : '' }}
                          </span>
                        </div>
                        <div class="media">
                          <div class="media-body">
                            
                            <div class="card">
                              <div class="card-body mt-3">
                                <h5 class="mt-0"><i class="uil uil-file-alt"></i> {{ item.title }}</h5>
                                <p class="text-muted">
                                  {{ item.description }}
                                </p>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Notes">
            <div class="card shadow-none">
              <div
                class="d-flex tab_card_content_container align-items-center flex-wrap"
                :class="model.notes && model.notes.length >= 2 ? 'justify-content-between' : 'justify-content-start'"
              >
                <div class="w-100 d-flex justify-content-end border-bottom">
                  <label class="btn btn-sm btn-primary text-center" @click.prevent="$refs.addNote.show()">
                    Add Summary 
                  </label>
                </div>


                <div class="note" v-if="model.notes.length == 0">
                  No candidate note added.
                </div>

                <div
                  class="note note_cards rounded my-2"
                  v-for="(note, idx) in model.notes"
                  :key="note._id || idx"
                  v-html="note.description"
                />

              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>

    <Loading :loading="loading"/>

    <Dialog
      ref="addNote"
      centered
      size="md"
      title="Add Note"
      yesText="Add"
      noText="Cancel"
      :parameters="{ submitted }"
      :component="addNoteComponent"
      @onYes="onAddNote"
    />
  </div>
</template>

<script>
import moment from 'moment/moment'
import pdf from 'vue-pdf'
import applicantProgress from '@components/applicantProgress'
import NoteComponent from './note.vue'
import Dialog from '@components/dialogs'

import error from '@utils/error'
import  FormMixin from '@mixins/form'
import Loading from '@components/LoadingSpinner'
import DataTable from '@common/datatable6'

export default {
  mixins:[FormMixin],
  components: {
    pdf,
    applicantProgress,
    Dialog,
    Loading,
    DataTable
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    candidateID() {
      let parameters = this.parameters || {}
      return parameters.candidateID
    },
    addNoteComponent() {
      return NoteComponent
    },
    computedSocmed() {
      return this.model.facebook || this.model.twitter || this.model.behance || this.model.dribble
    }
  },
  data() {
    return {
      model: {
        full_name: '',
        email: '',
        contact_no: '',
        work_experiences:[],
        education_background:[],
        skills:[],
        tags:[],
        attachments:[],
        activities:[],
        applications:[],
        notes:[],
        job_id:{
          title:'',
          company_id:{
            name:''
          }
        },
        functions:['none'],
      },
      attachmentPDFDatas: [],
      attachmentDatas: [],
      application:{},
      tag:{},
      showTag:false,
      submitted: false,
      loading: false
    }
  },
  methods: {
    onClickActions(mode, val) {
      this.$emit('onClick', { type: 'ref', method: mode, data: val, isEdit: true })
    },
    onClickAddAttachment() {
      let attachmentField = this.$refs.attachmentField

      if (attachmentField) {
        attachmentField.click()
      }
    },
    onAddAttachment(e) {
      let input = e.target

      if (input.files && input.files[0]) {
        this.toggleLoading()
        this.loading = true
        
        var formData = new FormData();

        formData.append("file", input.files[0]);
        formData.append("id", this.candidateID);

        this.$store.dispatch('candidate/uploadAttachment', formData)
        .then(async res => {
          if(res.data.success == true){
            await this.fetchData(false)
            await this.parseDocuments()
          }
          else{
            return error.errorHandler({ message: 'Upload unsuccessful!' }, this.$bvToast)
          }
          this.toggleLoading()
          this.loading = false
        })
        .catch(err => error.errorHandler(err, this.$bvToast))
      }
    },
    onAddNote(val){
      let model = val && val.model && Object.entries(val.model).length ? val.model : val

      this.$store.dispatch('candidate/createNote', {
        id: this.model._id,
        note: model.note
      })
      .then(res => {
        var data = res.data
        this.submitted = !this.submitted
        this.fetchData()
        this.$refs.addNote.hide()
        this.$bvToast.toast(data.toastMessage, {
          title: 'Notification',
          variant:'success'
        })
      })
      .catch((err) => error.errorHandler(err, this.$bvToast))
    },
    fetchData(loadDoc = true) {
      let param = {}
      param.id = this.candidateID

      return this.$store.dispatch('candidate/findCandidate', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
          if(loadDoc)
            this.parseDocuments()

        }
      })
    },
    parseDocuments(){
      this.attachmentDatas = []
      this.attachmentPDFDatas = []
      let attachmentData = this.model.attachments
      if(attachmentData.length > 0){
        for(let index = 0; index < attachmentData.length; index++) {
          const element = attachmentData[index];
          if(element.mimetype == 'application/pdf'){
            let pdfsrc = pdf.createLoadingTask(`${process.env.VUE_APP_SERVER_URL}/${element.path}`)
            let numPages = undefined

            pdfsrc.promise.then(pdf => {
              pdfsrc._worker.destroy()
              numPages = pdf._pdfInfo.numPages;
              let result = {
                src: pdfsrc,
                numPages,
                currentPage: 0,
                fileName: element.originalname,
                size: element.size,
                _id: element._id,
                isActive: attachmentData.length > 1 ? false : true
              }
              this.attachmentPDFDatas.push(result)
            })
          }else{
            let result = {
              fileName: element.originalname,
              size: element.size,
              _id: element._id,
              isActive: false
            }
            this.attachmentDatas.push(result)
          }

          if(element.converted_file) {
            let pdfsrc = pdf.createLoadingTask(`${process.env.VUE_APP_SERVER_URL}/${element.path}`)
            let numPages = undefined
            pdfsrc.promise.then(pdf => {
              numPages = pdf._pdfInfo.numPages;
              let result = {
                src: pdfsrc,
                numPages,
                currentPage: 0,
                fileName: this.formattedFileName(element.originalname),
                size: element.size,
                _id: element._id,
                isActive: attachmentData.length > 1 ? false : true,
                converted_file: true
              }
              this.attachmentPDFDatas.push(result)
            })
          }
        }
      }
    },
    formattedFileName(name) {
      return name.replace(/.docx|.pdf|.doc|.xlsx/gi, ".pdf");
    },
    onViewAttachment(uiid){
      this.$store.dispatch('candidate/downloadAttachment', {
        id:uiid
      }).then(res => {
        console.log(res);
      })
    },
    onDownloadAttachment(uiid, converted_file = false){
      this.$store.dispatch('candidate/downloadAttachment', {
        id:uiid,
        converted_file
      }).then(res => {
        if(res.data.errorMessage){
          return error.errorHandler(res, this.$bvToast)
          // alert(res.data.errorMessage)
        }
        else {
          if(res.data){
            const url = res.data.baseUrl + '/' + res.data.attachment.path
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', res.data.originalname) //or any other extension
            link.setAttribute('target', '_blank') //or any other extension
            document.body.appendChild(link)
            link.click()
            link.remove()
          }
        }
        
      })
    },
    onDeleteAttachment(uiid){
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete selected attachment?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DELETE',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      .then(res => {
        if(res == true){
          this.$store.dispatch('candidate/deleteAttachment', { id:uiid })
          .then(async res => {
            if(res.data.success){
              await this.fetchData(false)
              await this.parseDocuments()
              this.$bvToast.toast('Attachment successfully deleted!', {
                title: 'Notification',
                variant:'success'
              })
            }
          })
        }
      })
      .catch(err => error.errorHandler(err, this.$bvToast))
    },
  },
  watch: {
    candidateID() {
      this.fetchData()
    }
  },
  mounted() {
    if (this.candidateID) {
      this.fetchData()
    }
    if(this.$refs['list'])
    this.$refs['list'].fetchData(false, 'active')
  },
  filters: {
    date: function (value, format) {
      return moment(value).format(format || 'YYYY-MM-DD')
    },
    custom_date: function (value) {
      return moment(value).format('Mo MMMM YYYY')
    }
  },
}
</script>

<style lang="scss">
  @media screen and (min-width: 1200px) {
    .col-3s {
      flex: 0 0 28%;
      max-width: 28%;
      padding-left: 12px;
      padding-right: 12px;
    }
    .col-8s {
      flex: 0 0 70%;
      max-width: 70%;
    }

    .w {
      height: 74vh;
      overflow-y: auto;
      overflow-x: hidden;
      .nav.nav-tabs {
        border-bottom: 3px solid rgb(54, 153, 255);    
      }
    }

    .tab_card_content_container {
      height: 100%;
      overflow: auto;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 15px;
    }

    .note_cards {
      font-weight: 600;
      padding: 15px;
      max-width: 100%;
      word-break: break-all;
      // background: #e8eaee;
      // height: 160px;
      // overflow: auto;
      // width: 48%;
      // max-width: 48%;
      // flex: 0 0 48%;
    }

    .button_container {
      z-index: 999;
      cursor: pointer;
      position: absolute;
      width: 50px;
      top: 0;
      right: 0;
      transition: width 0.2s;
      display: flex;
      align-items: center!important;
      justify-content: center;
    }

    .card_body_background {
      background: #e8eaee;
    }
  }
</style>